import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // DESIGN.md, Fields: shallow inset surface, clear control-edge boundary.
        // Focus strengthens the outline without moving the layout.
        "h-9 w-full min-w-0 rounded-md border border-halo-control-edge bg-halo-inset px-2.5 py-1 text-base text-halo-ink transition-[border-color] duration-120 outline-none selection:bg-halo-accent selection:text-halo-on-accent file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-halo-ink placeholder:text-halo-muted disabled:cursor-not-allowed disabled:border-halo-line disabled:bg-halo-canvas disabled:text-halo-secondary md:text-sm",
        "focus-visible:border-halo-accent-ink focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-2 focus-visible:outline-halo-accent-ink",
        "aria-invalid:border-halo-danger",
        className
      )}
      {...props}
    />
  )
}

export { Input }
